import type { FloraInstance, Vec3 } from '@/flora/FloraInstance';
import { cloneFloraInstanceIndependent } from '@/flora/FloraInstance';

/**
 * Produce fully independent copies of instances, offset in the ground plane (spec §4.4). Each copy
 * gets a fresh id and is detached from any alias group, so later edits to a source never propagate
 * to its duplicate.
 */
export function duplicateInstances(
  instances: Iterable<FloraInstance>,
  offset: Vec3 = { x: 1, y: 0, z: 1 },
): FloraInstance[] {
  const copies: FloraInstance[] = [];
  for (const source of instances) {
    const clone = cloneFloraInstanceIndependent(source);
    clone.position = {
      x: source.position.x + offset.x,
      y: source.position.y + offset.y,
      z: source.position.z + offset.z,
    };
    copies.push(clone);
  }
  return copies;
}
